(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product__tabs-nav').forEach(function (nav) {
      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('.product__tab-btn');
        if (!btn) return;
        var container = nav.closest('.product__description-tabs');
        var tab = btn.dataset.tab;

        nav.querySelectorAll('.product__tab-btn').forEach(function (b) {
          b.classList.remove('product__tab-btn--active');
        });
        btn.classList.add('product__tab-btn--active');

        container.querySelectorAll('.product__tab-panel').forEach(function (p) {
          p.classList.remove('product__tab-panel--active');
        });
        container.querySelector('[data-panel="' + tab + '"]').classList.add('product__tab-panel--active');
      });
    });
  });
})();
